import { accountSellable, accountIsFullSale } from "./helpers";
import { needsSlots, sellableProfiles } from "./catalog";

export function activationProfiles(account, deliveries, index) {
  const taken = new Set(deliveries.filter((_, i) => i !== index).map(row => Number(row.profileId)).filter(Boolean));
  return sellableProfiles(account).filter(profile => !taken.has(Number(profile.id)));
}

export function activationAccounts(accounts, deliveries, index) {
  const delivery = deliveries[index];
  return accounts.filter(account => {
    if (Number(account.productId) !== Number(delivery.productId) || !accountSellable(account)) return false;
    const others = deliveries.filter((row, i) => i !== index && Number(row.accountId) === Number(account.id));
    if (others.length && (accountIsFullSale(account) || others.some(row => !row.profileId))) return false;
    return !needsSlots(account) || accountIsFullSale(account) || activationProfiles(account, deliveries, index).length > 0;
  });
}
